import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#FFEFFD"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.543 16.2266C22.543 16.7578 22.4688 17.2227 22.3203 17.6211C22.1797 18.0117 21.9766 18.3516 21.7109 18.6406C21.4453 18.9219 21.125 19.1641 20.75 19.3672C20.3828 19.5703 19.9727 19.7422 19.5195 19.8828V20C20.0742 20.1406 20.5781 20.3359 21.0312 20.5859C21.4922 20.8281 21.8867 21.1289 22.2148 21.4883C22.5508 21.8398 22.8086 22.25 22.9883 22.7188C23.1758 23.1875 23.2695 23.7148 23.2695 24.3008C23.2695 25.8789 22.6953 27.0586 21.5469 27.8398C20.3984 28.6133 18.6836 29 16.4023 29H8.66797V27.7227H9.65234C9.83203 27.7227 9.99609 27.707 10.1445 27.6758C10.3008 27.6367 10.4336 27.5625 10.543 27.4531C10.6523 27.3438 10.7383 27.1875 10.8008 26.9844C10.8711 26.7812 10.9062 26.5078 10.9062 26.1641V14.668C10.9062 14.3477 10.8711 14.0898 10.8008 13.8945C10.7383 13.6914 10.6484 13.5352 10.5312 13.4258C10.4219 13.3164 10.2891 13.2422 10.1328 13.2031C9.98438 13.1562 9.82422 13.1328 9.65234 13.1328H8.66797V11.8672H15.6758C17.957 11.8672 19.6719 12.2188 20.8203 12.9219C21.9688 13.625 22.543 14.7266 22.543 16.2266ZM14.6914 27.5352H16.2852C16.8164 27.5352 17.2695 27.4766 17.6445 27.3594C18.0195 27.2422 18.3242 27.0547 18.5586 26.7969C18.793 26.5312 18.9609 26.1875 19.0625 25.7656C19.1719 25.3438 19.2266 24.8281 19.2266 24.2188C19.2266 23.6328 19.1797 23.125 19.0859 22.6953C18.9922 22.2578 18.832 21.8984 18.6055 21.6172C18.3789 21.3359 18.082 21.125 17.7148 20.9844C17.3477 20.8438 16.8867 20.7734 16.332 20.7734H14.6914V27.5352ZM14.6914 19.3086H15.6055C16.168 19.3086 16.6328 19.25 17 19.1328C17.375 19.0156 17.6719 18.8359 17.8906 18.5938C18.1172 18.3438 18.2773 18.0234 18.3711 17.6328C18.4648 17.2422 18.5117 16.7734 18.5117 16.2266C18.5117 15.6797 18.457 15.2227 18.3477 14.8555C18.2461 14.4883 18.0781 14.1914 17.8438 13.9648C17.6094 13.7383 17.3047 13.5781 16.9297 13.4844C16.5547 13.3828 16.0977 13.332 15.5586 13.332H14.6914V19.3086Z",
      fill: "#62153E"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#62153E"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#D2388A"
    }, null, -1)
  ])))
}
export default { render: render }